var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',{attrs:{"color":"error"}},[_vm._v("warning")]),_c('v-btn',_vm._g({attrs:{"color":"primary","dark":""}},on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.$tf('CapsLock activated')))])])}
var staticRenderFns = []

export { render, staticRenderFns }